import { useState } from "react";
import { TrendingDown, TrendingUp, ChevronDown, ChevronRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const ScoreBreakdown = ({ card }) => {
  const lines = card?.score_breakdown || [];
  const [open, setOpen] = useState(null);
  if (!lines.length) return null;

  return (
    <Card className="border-brand-line shadow-none" data-testid="score-breakdown">
      <CardHeader>
        <CardTitle className="text-lg">Score breakdown</CardTitle>
        <p className="text-sm text-slate-500">
          Tier readiness{" "}
          <span className="font-semibold text-brand-ink">
            {(card.tier_readiness ?? 0).toFixed(1)}
          </span>
        </p>
      </CardHeader>
      <CardContent className="space-y-2">
        {lines.map((l) => {
          const bad = l.kind === "deduction";
          const active = bad && l.points < 0;
          const hasChildren = l.children && l.children.length > 0;
          const isOpen = open === l.key;
          return (
            <div key={l.key}>
              <div
                data-testid={`score-line-${l.key}`}
                onClick={() => hasChildren && setOpen(isOpen ? null : l.key)}
                className={`flex items-start justify-between gap-4 rounded-md px-3 py-2.5 ${
                  active ? "bg-rose-50" : bad ? "bg-slate-50" : "bg-emerald-50/60"
                } ${hasChildren ? "cursor-pointer" : ""}`}
              >
                <div>
                  <p
                    className={`flex items-center gap-1.5 text-sm font-semibold ${
                      active ? "text-rose-700" : bad ? "text-slate-600" : "text-brand-ink"
                    }`}
                  >
                    {hasChildren ? (
                      isOpen ? <ChevronDown className="h-3.5 w-3.5" /> : <ChevronRight className="h-3.5 w-3.5" />
                    ) : bad ? (
                      <TrendingDown className="h-3.5 w-3.5" strokeWidth={2} />
                    ) : (
                      <TrendingUp className="h-3.5 w-3.5" strokeWidth={2} />
                    )}
                    {l.label}
                    {!bad && l.weight ? (
                      <span className="rounded bg-white/70 px-1.5 py-0.5 text-[10px] font-medium text-slate-500">
                        {l.weight}% weight
                      </span>
                    ) : null}
                    {!bad && l.value ? (
                      <span className="text-xs font-normal text-slate-500">· {l.value}</span>
                    ) : null}
                  </p>
                  <p className="mt-0.5 text-xs text-slate-500">{l.detail}</p>
                </div>
                <p
                  className={`shrink-0 font-display text-base font-semibold ${
                    active ? "text-rose-700" : bad ? "text-slate-400" : "text-emerald-700"
                  }`}
                >
                  {l.points > 0 ? "+" : ""}
                  {l.points.toFixed(1)}
                </p>
              </div>
              {hasChildren && isOpen && (
                <div className="ml-6 mt-1 space-y-1" data-testid={`score-children-${l.key}`}>
                  {l.children.map((c) => (
                    <div key={c.month} className="flex items-center justify-between text-xs text-slate-600">
                      <span>{c.month} <span className="text-slate-400">· {c.weight}% of history</span></span>
                      <span className="font-semibold text-brand-ink">{c.score}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}

      </CardContent>
    </Card>
  );
};
